module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: 'https://liuruis.cn/img/bg1.jpg',
	bg2: 'https://liuruis.cn/img/bg2.jpg',
	bg3: 'https://liuruis.cn/img/bg3.jpg',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: 'Liuruis\'s Blog'
}
